import React from 'react';
import { useNavigate } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';

/**
 * Wrapper para ErrorBoundary que proporciona navigate usando hooks
 * ErrorBoundary debe ser una clase, pero useNavigate es un hook
 */
const ErrorBoundaryWrapper = ({ children }) => {
  const navigate = useNavigate();

  return (
    <ErrorBoundary navigate={navigate}>
      {children}
    </ErrorBoundary>
  );
};

export default ErrorBoundaryWrapper;

